import { Component, Input } from '@angular/core';
import { Summary } from './models/summary.interfaces';

@Component({
  selector: 'idp-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent {
  @Input() content: Summary = {} as Summary;

  goTo(link: string) {
    window.open(link, '_self');
  }
}
